import { InputFactory } from "../../nq-component";
import React, { useState, useEffect } from "react";
import { saveFileUseCase } from "../../usecases/file";

const ResignationFormModal = ({
  show,
  onClose,
  onSubmit,
  currentUser,
  isSubmitting = false,
}) => {
  const [formData, setFormData] = useState({
    employeeId: currentUser?.id || "",
    resignationType: "",
    effectiveDate: "",
    separationDate: "",
    reason: "",
    resignationLetter: null,
    acl: {
      read: ["*"],
      write: ["*"],
    },
  });

  // Calculate date 30 days from now
  const [minEffectiveDate, setMinEffectiveDate] = useState("");

  useEffect(() => {
    const today = new Date();
    const thirtyDaysFromNow = new Date();
    thirtyDaysFromNow.setDate(today.getDate() + 30);

    // Format date as YYYY-MM-DD for the input
    const formattedDate = thirtyDaysFromNow.toISOString().split("T")[0];
    setMinEffectiveDate(formattedDate);
  }, []);

  const [fileName, setFileName] = useState("");
  const [uploadProgress, setUploadProgress] = useState(0);
  const [isUploading, setIsUploading] = useState(false);

  const handleChange = (field, value) => {
    setFormData({
      ...formData,
      [field]: value,
    });
  };

  const handleFileUpload = (value) => {
    if (value) {
      setIsUploading(true);

      let progress = 0;
      const progressInterval = setInterval(() => {
        progress += 10;
        setUploadProgress(progress);

        if (progress >= 100) {
          clearInterval(progressInterval);
          setIsUploading(false);

          setFormData({
            ...formData,
            resignationLetter: value,
          });

          if (value && value.name) {
            setFileName(value.name);
          } else if (typeof value === "string") {
            const urlParts = value.split("/");
            const fullFileName = urlParts[urlParts.length - 1];

            if (fullFileName.includes("_")) {
              const cleanFileName = fullFileName.split("_")[1];
              setFileName(cleanFileName);
            } else {
              setFileName(fullFileName);
            }
          }
        }
      }, 200);
    }
  };

  const [showValidationMessage, setShowValidationMessage] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();

    const errors = {};
    if (!formData.resignationType)
      errors.resignationType = "Resignation type is required";
    if (!formData.effectiveDate)
      errors.effectiveDate = "Effective date is required";
    // Commented out the separation date validation since we're hiding the field
    // if (!formData.separationDate)
    //   errors.separationDate = "Separation date is required";
    if (!formData.reason) errors.reason = "Reason is required";
    // Removed the resignationLetter validation since it's now optional
    // if (!formData.resignationLetter)
    //   errors.resignationLetter = "Resignation letter is required";

    if (Object.keys(errors).length > 0) {
      setShowValidationMessage(true);

      setTimeout(() => {
        setShowValidationMessage(false);
      }, 3000);

      return;
    }

    onSubmit(formData);
  };

  return (
    show && (
      <div
        className="modal d-block"
        tabIndex="-1"
        style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div
            className="modal-content"
            style={{
              borderRadius: "8px",
              boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
              border: "none",
            }}
          >
            <div
              className="modal-header border-0 pb-0"
              style={{
                marginTop: "12px",
                marginLeft: "10px",
                marginBottom: "-20px",
              }}
            >
              <h5
                className="modal-title d-flex align-items-center"
                style={{ color: "#D18237", fontSize: "18px" }}
              >
                <div
                  style={{
                    backgroundColor: "#F5F5F5",
                    borderRadius: "15%",
                    width: "45px",
                    height: "45px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginRight: "10px",
                    fontSize: "30px",
                  }}
                >
                  <i className="bi bi-person-x"></i>
                </div>
                Request for Resignation
              </h5>
            </div>
            <div className="modal-body" style={{ padding: "50px" }}>
              <form onSubmit={handleSubmit}>
                <div className="mb-3">
                  <label
                    className="form-label mb-2"
                    style={{ fontSize: "14px", fontWeight: "500" }}
                  >
                    Type of Resignation <span className="text-danger">*</span>
                  </label>
                  <div className="position-relative">
                    <InputFactory
                      type="Enum"
                      placeholder="Select"
                      options={["Voluntary"]}
                      onChange={(value) =>
                        handleChange("resignationType", value)
                      }
                    />
                    <span
                      className="position-absolute"
                      style={{
                        right: "15px",
                        top: "50%",
                        transform: "translateY(-50%)",
                      }}
                    >
                      <i className="bi bi-chevron-down text-muted"></i>
                    </span>
                  </div>
                </div>
                <div className="mb-3">
                  <label
                    className="form-label mb-2"
                    style={{ fontSize: "14px", fontWeight: "500" }}
                  >
                    Effective Date <span className="text-danger">*</span>
                  </label>
                  <div className="position-relative">
                    <InputFactory
                      type="Date"
                      value={formData.effectiveDate}
                      onChange={(value) => handleChange("effectiveDate", value)}
                      min={minEffectiveDate}
                    />
                  </div>
                </div>
                {/* Commented out the Date of separation field to hide it
                <div className="mb-3">
                  <label
                    className="form-label mb-2"
                    style={{ fontSize: "14px", fontWeight: "500" }}
                  >
                    Date of separation <span className="text-danger">*</span>
                  </label>
                  <div className="position-relative">
                    <InputFactory
                      type="Date"
                      value={formData.separationDate}
                      onChange={(value) =>
                        handleChange("separationDate", value)
                      }
                    />
                  </div>
                </div>
                */}
                <div className="mb-3">
                  <label
                    className="form-label mb-2"
                    style={{ fontSize: "14px", fontWeight: "500" }}
                  >
                    Reason <span className="text-danger">*</span>
                  </label>
                  <textarea
                    className="form-control"
                    rows="3"
                    placeholder="Enter Reason"
                    value={formData.reason}
                    onChange={(e) => handleChange("reason", e.target.value)}
                    style={{
                      borderColor: "#E0E0E0",
                      borderRadius: "6px",
                      padding: "10px 15px",
                      fontSize: "14px",
                      boxShadow: "none",
                    }}
                  ></textarea>
                </div>
                {/* <label
                  className="form-label mb-2"
                  style={{ fontSize: "14px", fontWeight: "500" }}
                >
                  Upload File{" "}
                </label>
                <div className="mb-2">
                  <div
                    className="d-flex align-items-center justify-content-start"
                    style={{
                      width: "100%",
                      height: "55px",
                      border: "2px dashed #D18237",
                      borderRadius: "6px",
                      cursor: "pointer",
                      backgroundColor: "#fff",
                      position: "relative",
                      overflow: "hidden",
                    }}
                  >
                    <i
                      className="bi bi-upload ms-3 me-3"
                      style={{ color: "#D18237", fontSize: "16px" }}
                    ></i>
                    <span
                      style={{
                        color: "#D18237",
                        fontSize: "14px",
                        fontWeight: "500",
                      }}
                    >
                      {fileName ? fileName : "Upload (Optional)"}
                    </span>

                    <InputFactory
                      type="String"
                      _type="File"
                      saveFile={saveFileUseCase()}
                      object={formData}
                      field="resignationLetter"
                      className="w-100 position-absolute z-2 opacity-0"
                      onChange={(value) => handleFileUpload(value)}
                    />
                  </div>
                </div> */}

                {/* Upload Progress Bar */}
                {isUploading && (
                  <div className="mb-3">
                    <div className="d-flex align-items-center">
                      <div
                        className="progress flex-grow-1"
                        style={{ height: "8px" }}
                      >
                        <div
                          className="progress-bar"
                          role="progressbar"
                          style={{
                            width: `${uploadProgress}%`,
                            backgroundColor: "#D18237",
                          }}
                          aria-valuenow={uploadProgress}
                          aria-valuemin="0"
                          aria-valuemax="100"
                        ></div>
                      </div>
                      <span
                        className="ms-2"
                        style={{ fontSize: "12px", color: "#6c757d" }}
                      >
                        {uploadProgress}%
                      </span>
                    </div>
                  </div>
                )}

                {/* File Upload Success Message */}
                {!isUploading && fileName && (
                  <div className="mb-3">
                    <div
                      className="d-flex align-items-center"
                      style={{ fontSize: "12px", color: "#198754" }}
                    >
                      <i className="bi bi-check-circle me-1"></i>
                      File uploaded successfully
                    </div>
                  </div>
                )}
              </form>

              {showValidationMessage && (
                <div
                  className="alert alert-warning alert-dismissible fade show mt-3"
                  role="alert"
                >
                  <strong>Please fill out all required fields</strong>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => setShowValidationMessage(false)}
                    aria-label="Close"
                  ></button>
                </div>
              )}
            </div>
            <div
              className="modal-footer border-0 d-flex gap-1 justify-content-center"
              style={{
                padding: "0px 20px 20px",
                marginTop: "-20px",
                zIndex: "1",
              }}
            >
              <button
                type="button"
                className="btn"
                onClick={handleSubmit}
                disabled={isSubmitting || isUploading}
                style={{
                  backgroundColor: "#D18237",
                  color: "white",
                  borderRadius: "6px",
                  border: "none",
                  padding: "10px 20px",
                  fontSize: "14px",
                  fontWeight: "500",
                  width: "38%",
                  height: "47px",
                }}
              >
                {isSubmitting ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Submitting...
                  </>
                ) : (
                  "Submit"
                )}
              </button>
              <button
                type="button"
                className="btn btn-light"
                onClick={onClose}
                style={{
                  backgroundColor: "#D0D0D0",
                  color: "#373A3C",
                  borderRadius: "6px",
                  border: "none",
                  padding: "10px 20px",
                  fontSize: "14px",
                  fontWeight: "500",
                  width: "38%",
                  height: "47px",
                }}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    )
  );
};

export default ResignationFormModal;
